module.exports = __webpack_public_path__ + "img/OFFICES_TOTAL.9674d12b.svg";